import { ENV_JS } from "../utils/env_module"

callpy_global.CLoader = function()
{
    this.module_name = "Loader ";
    this.module_log_rang = 100;

    var _this = this;

    this.load_callpy = function()
    {
        //console.log('m_callpy->0', m_callpy)
        var tmp;
        //FIXED MULTISITE: для консультанта - отдельный запрос
        if (m_callpy.client_data.type != 1){
            
            if (m_callpy.client_data.type!=2){
                //TODO: запрос, который просто вернет данные по site и т.п. (без инициализации клиента). Не кешируется
                if (m_callpy.client_data.type==5){
                    // $jcallpy.ajax({   type: "POST",
                    //     url: (location.protocol=="http:"?callpy_global.php_server.replace("https", "http"):callpy_global.php_server) + "admn/",
                    //     data: {action: "get_chat_client_data", site_id: window.global_site_id},
                    //     success:
                    //         function (msg)
                    //         {
                    //             msg = JSON.parse(msg);
                    //             m_callpy.client_data.site = msg.site_info.domain;
                    //             m_callpy.client_data.site_info = msg.site_info;
                    //             m_callpy.client_data.key = 0;
                    //             m_callpy.client_data.channel = "";
                    //             m_callpy.client_data.peer_key = msg.manager.id;
                    //             m_callpy.client_data.peer_type = 2;
                    //             m_callpy.client_data.site_id = msg.site_info.id;
                    //             m_callpy.client_data.department_id = msg.department_id;
                    //             m_callpy.client_data.clientInfo = {userData: null, formData: null};
                    //             m_callpy.managers_list = {};
                    //             m_callpy.managers_list[msg.manager.id] = msg.manager;
                    //             m_callpy.managers_list[msg.manager.id].key = msg.manager.id;
                    //             //TODO: инициализация чата (только GUI)
                    //             m_callpy.m_storage = callpy_global.registerModule("callpy_global.CStorage");
                    //             m_callpy.m_user = callpy_global.registerModule("callpy_global.CUser");
                    //             m_callpy.m_chat = callpy_global.registerModule("callpy_global.CChat");
                    //             if (global_widgetUpdated == 1) localStorage.removeItem("callpy_css");

                    //             $jcallpy.callpy_init("_init");
                    //         }
                    // });
                    
                    fetch((location.protocol=="http:"?callpy_global.php_server.replace("https", "http"):callpy_global.php_server) + "admn/", {
                      method: 'post',
                      body: {action: "get_chat_client_data", site_id: window.global_site_id},
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      }
                    }).then((response) => {
                      return response.json()
                    }).then((res) => {
                        if (res.status === 201) {
                          console.log(`Post successfully created! res=>: ${res}`)
                          const msg = res?.data??null
                          if(msg) {
                            msg = JSON.parse(msg);
                            m_callpy.client_data.site = msg.site_info.domain;
                            m_callpy.client_data.site_info = msg.site_info;
                            m_callpy.client_data.key = 0;
                            m_callpy.client_data.channel = "";
                            m_callpy.client_data.peer_key = msg.manager.id;
                            m_callpy.client_data.peer_type = 2;
                            m_callpy.client_data.site_id = msg.site_info.id;
                            m_callpy.client_data.department_id = msg.department_id;
                            m_callpy.client_data.clientInfo = {userData: null, formData: null};
                            m_callpy.managers_list = {};
                            m_callpy.managers_list[msg.manager.id] = msg.manager;
                            m_callpy.managers_list[msg.manager.id].key = msg.manager.id;
                            //TODO: инициализация чата (только GUI)
                            m_callpy.m_storage = callpy_global.registerModule("callpy_global.CStorage");
                            m_callpy.m_user = callpy_global.registerModule("callpy_global.CUser");
                            m_callpy.m_chat = callpy_global.registerModule("callpy_global.CChat");
                            if (global_widgetUpdated == 1) localStorage.removeItem("callpy_css");

                            $jcallpy.callpy_init("_init");
                          }
                          
                        }
                    }).catch((error) => {
                      console.log(error)
                    })
                    
                    return;
                }
                if (m_callpy.client_data.type == 3){
                    //TODO: передача данных о текущем URL на сервер callpy и далее клиенту, только в случае удалённой навигации
                }
                //tmp = m_callpy.m_bridge.format_data(m_callpy.m_message.create_message("get_scripts", {0: m_callpy.client_data.site, 1: m_callpy.client_data.browser[0], 2: m_callpy.client_data.type}));
                //tmp = m_callpy.m_bridge.format_data(m_callpy.m_message.create_message("user_data", {0: m_callpy.client_data.site, 1: m_callpy.client_data.browser[0], 2: m_callpy.client_data.type}));
            }else{
                tmp = m_callpy.m_bridge.format_data(m_callpy.m_message.create_message("get_scripts_mng", {
                    "site": "multi",
                    "browser": m_callpy.client_data.browser[0],
                    "type": m_callpy.client_data.type,
                    "webRTCsupp": ((window.mozRTCPeerConnection || window.webkitRTCPeerConnection || window.RTCPeerConnection) && (navigator.userAgent.indexOf("Chrome/") != -1 || navigator.getUserMedia || navigator.mozGetUserMedia || (navigator.mediaDevices && navigator.mediaDevices.getUserMedia))?1:0)
                }));
            }

        }
        else{
          
            //сначала определим, новый ли это клиент (по куке и LS):
            var tmp_id, tmp_chnl, fEnter, visits;

            if (!m_callpy.m_cookie.get_cookie("callpy_key") || m_callpy.m_cookie.get_cookie("callpy_key")== "NaN" || m_callpy.m_cookie.get_cookie("callpy_key")== "0" || m_callpy.m_cookie.get_cookie("callpy_key")== "null" || !m_callpy.m_cookie.get_cookie("callpy_chnl") || m_callpy.m_cookie.get_cookie("callpy_chnl")== "NaN"){
                if (!callpy_from_ls || !callpy_storage.m_callpy.client_data.key || callpy_storage.m_callpy.client_data.key == "0" || callpy_storage.m_callpy.client_data.key == "null"){ //нет данных об ID ни в куке, ни в LS
                    callpy_from_ls = false;
                    tmp_id = 0;
                    tmp_chnl='';
                    //запишем дату первого посещения
                    fEnter = Math.floor(new Date().getTime()/1000);
                    localStorage.setItem("callpy_fEnt", fEnter);
                }else{ //куки нет, но состояние восстанавливали из LS - необходимо установить куку
                    m_callpy.m_cookie.set_cookie("callpy_key", callpy_storage.m_callpy.client_data.key, "Mon, 01-Jan-2101 00:00:00 GMT", '/');
                    m_callpy.m_cookie.set_cookie("callpy_chnl", callpy_storage.m_callpy.client_data.channel, "Mon, 01-Jan-2101 00:00:00 GMT", '/');
                    m_callpy.client_data.key = parseInt(callpy_storage.m_callpy.client_data.key);
                    m_callpy.client_data.channel = callpy_storage.m_callpy.client_data.channel;
                    tmp_id = m_callpy.client_data.key;
                    tmp_chnl = callpy_storage.m_callpy.client_data.channel;
                    //this.set_new_key({key: m_callpy.client_data.key, nocookie: true, channel: m_callpy.client_data.channel});
                }
            }else{
                tmp_id = m_callpy.m_cookie.get_cookie("callpy_key");
                tmp_chnl = m_callpy.m_cookie.get_cookie("callpy_chnl");
            }
            fEnter = localStorage.getItem("callpy_fEnt");
            if (!fEnter){
                fEnter = Math.floor(new Date().getTime()/1000);
                localStorage.setItem("callpy_fEnt", fEnter);
            }
            visits = localStorage.getItem("callpy_vsts");
            if (!visits) visits = 0;
            visits++;
            if (!callpy_from_ls) localStorage.setItem("callpy_vsts", visits);
            //fix window.location.origin for ie
            console.log('window.location.', window.location, callpy_global)
            console.log('m_callpy', m_callpy)
            if (!window.location.origin) {
              window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
            }
            //tmp = m_callpy.m_bridge.format_data(m_callpy.m_message.create_message("get_scripts", {0: m_callpy.client_data.site, 1: navigator.userAgent, 2: m_callpy.client_data.type, 3: tmp_id, 4: (callpy_from_ls?1:0), 5: encodeURIComponent(window.location.href), 6: (document.mozHidden || document.msHidden || document.webkitHidden || document.hidden?1:0), 7:(window.mozRTCPeerConnection || window.webkitRTCPeerConnection?1:0), 8: encodeURIComponent(window.location.origin), 9: $jcallpy(window).width(), 10: tmp_chnl}));
            if (callpy_from_ls) tmp = m_callpy.m_bridge.format_data(m_callpy.m_message.create_message("user_data", {
                "site": encodeURIComponent(m_callpy.client_data.site),
                "pid": window.callpy_pid? window.callpy_pid : 0,
                "browser": navigator.userAgent,
                "type": m_callpy.client_data.type,
                "key": tmp_id,
                "from_ls": (callpy_from_ls?1:0),
                "referer": encodeURIComponent(ENV_JS.CALLPY_PHP_SERVER), //encodeURIComponent(window.location.href)
                "hidden": (document.mozHidden || document.msHidden || document.webkitHidden || document.hidden?1:0),
                "webRTCsupp":((window.mozRTCPeerConnection || window.webkitRTCPeerConnection || window.RTCPeerConnection) && (navigator.userAgent.indexOf("Chrome/") != -1 || navigator.getUserMedia || navigator.mozGetUserMedia || (navigator.mediaDevices && navigator.mediaDevices.getUserMedia))?1:0),
                "origin": encodeURIComponent(m_callpy.convertPunycode((window?.location?.origin.indexOf('localhost:')!==-1)?window.location.origin:ENV_JS?.CALLPY_ORIGIN_URL)),//m_callpy.convertPunycode(window.location.origin)
                "width": window.innerWidth,//$jcallpy(window).width(), 
                "channel": tmp_chnl,
                "title": document.title
            }));
            else tmp = m_callpy.m_bridge.format_data(m_callpy.m_message.create_message("user_data", {
                "site": encodeURIComponent(m_callpy.client_data.site),
                "pid": window.callpy_pid? window.callpy_pid : 0,
                "browser": navigator.userAgent,
                "type": m_callpy.client_data.type,
                "key": tmp_id,
                "from_ls": (callpy_from_ls?1:0),
                "referer": encodeURIComponent(ENV_JS.CALLPY_PHP_SERVER), //encodeURIComponent(window.location.href)
                "hidden": (document.mozHidden || document.msHidden || document.webkitHidden || document.hidden?1:0),
                "webRTCsupp":((window.mozRTCPeerConnection || window.webkitRTCPeerConnection || window.RTCPeerConnection) && (navigator.userAgent.indexOf("Chrome/") != -1 || navigator.getUserMedia || navigator.mozGetUserMedia || (navigator.mediaDevices && navigator.mediaDevices.getUserMedia))?1:0),
                "origin": encodeURIComponent(m_callpy.convertPunycode((window?.location?.origin.indexOf('localhost:')!==-1)?window.location.origin:ENV_JS?.CALLPY_ORIGIN_URL)),//m_callpy.convertPunycode(window.location.origin)
                "width": window.innerWidth,//$jcallpy(window).width(),
                "channel": tmp_chnl,
                "title": document.title,
                "enter": fEnter,
                "fromref": encodeURIComponent(document.referrer),
                "visits": visits,
                "lang": (m_callpy.client_data.site!='callpy.com'?callpy_global.language:null)
            }));

        }

        if (m_callpy.client_data.type==1||m_callpy.client_data.type==2) _this.load_script((m_callpy.client_data.type==1?(callpy_global.php_server + "d"):"/mngr") + "/?" + tmp , document.getElementsByTagName('head')[0], m_callpy.load_modules_complete);
        else m_callpy.load_modules_complete(); //FIXED: для фреймов второй запрос не нужен вообще
    };

    this.load_script = function (url, container, callback)
    {
      //console.log('m_callpy->1', url)
      
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url; // + new Date().getTime().toString();

        if (callback)
        {
            script.onload = callback;
        }

        container.appendChild(script);
    };

    this.load_css = function (url, container, callback)
    {
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = url; // + new Date().getTime().toString();

        if (callback)
        {
            css.onload = callback;
        }

        container.appendChild(css);
    };
};

